// extracted by mini-css-extract-plugin
export default {"termsOfService":"TermsOfService_termsOfService__cjIOU","title":"TermsOfService_title__nX2sg"};